import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaUsers, 
  FaShoppingCart, 
  FaChartLine, 
  FaCog, 
  FaSignOutAlt, 
  FaSearch, 
  FaTrash, 
  FaShieldAlt, 
  FaHeart, 
  FaBullhorn 
} from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faUsers as faUsr, faShoppingCart as faCart, faBullhorn as faHorn, faHeart as faH, faShieldAlt as faShield, faMicrochip } from '@fortawesome/free-solid-svg-icons';
import '../ProfileStyles/AdminCustomerProfilePage.css';

function AdminCustomerDashboard({ currentUser, onLogout }) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('stats');
  const [customers, setCustomers] = useState([]);
  const [reports, setReports] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [tickerText, setTickerText] = useState('FREE SHIPPING ON ALL ORDERS OVER $150');

  useEffect(() => {
    if (!currentUser || currentUser.accountType !== 'admin_customer') {
      navigate('/signin');
    } else {
      fetchData();
    }
  }, [currentUser, navigate, selectedTab]);

  const fetchData = async () => {
    const token = localStorage.getItem('token');
    if (selectedTab === 'users') fetchCustomers(token);
    if (selectedTab === 'stats') fetchReports(token);
  };

  const fetchCustomers = async (token) => {
    try {
      const res = await fetch('/api/admin/retailers/customers', { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setCustomers(Array.isArray(data) ? data : []);
    } catch (e) { console.error(e); }
  };

  const fetchReports = async (token) => {
    try {
      const res = await fetch('/api/admin/retailers/reports', { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setReports(data);
    } catch (e) { console.error(e); }
  };

  const deleteUser = async (id) => {
    if (!window.confirm('PERMANENTLY DELETE USER?')) return;
    try {
      const token = localStorage.getItem('token');
      await fetch(`/api/admin/retailers/users/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchCustomers(token);
    } catch (e) { console.error(e); }
  };

  const handleLogoutClick = () => { onLogout(); navigate('/'); };

  const renderContent = () => {
    switch (selectedTab) {
      case 'stats':
        return (
          <div className="terminal-dashboard animate-fade-in">
            <div className="dashboard-grid-hud">
              <div className="hud-card metric-primary">
                <div className="hud-card-edge"></div>
                <div className="hud-card-content">
                  <span className="hud-label">TOTAL CUSTOMERS</span>
                  <div className="hud-value-wrap">
                    <span className="hud-value highlight">{reports?.totalUsers || 0}</span>
                  </div>
                  <p className="hud-subtext">Active database identities</p>
                </div>
              </div>
              <div className="hud-card metric-secondary">
                <div className="hud-card-content">
                  <span className="hud-label">AVG SESSIONS</span>
                  <div className="hud-value-wrap">
                    <span className="hud-value">42</span>
                  </div>
                  <p className="hud-subtext">24-hour traffic movement</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'users':
        return (
          <div className="vault-interface animate-fade-in">
            <div className="console-input-row" style={{marginBottom: '30px'}}>
              <div className="input-group-tech">
                <span className="input-prefix">QUERY:</span>
                <input 
                  type="text" 
                  placeholder="SEARCH_BY_EMAIL..." 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div className="vault-table-container">
               <div className="vault-table-header" style={{gridTemplateColumns: '1fr 2fr 100px 100px'}}>
                  <span>USERNAME</span>
                  <span>EMAIL</span>
                  <span>STATUS</span>
                  <span>ACTIONS</span>
               </div>
               <div className="vault-table-body">
                 {customers.filter(c => c.email.toLowerCase().includes(searchQuery.toLowerCase())).map(user => (
                   <div key={user._id} className="vault-table-row" style={{gridTemplateColumns: '1fr 2fr 100px 100px'}}>
                     <span className="row-name" style={{fontSize: '11px'}}>{user.username}</span>
                     <span className="row-retailer-text">{user.email}</span>
                     <span className="row-status live">ACTIVE</span>
                     <button className="row-action-btn delete" onClick={() => deleteUser(user._id)}><FaTrash /></button>
                   </div>
                 ))}
               </div>
            </div>
          </div>
        );

      case 'orders':
        return (
          <div className="vault-interface animate-fade-in">
             <div className="vault-table-container">
               <div className="vault-table-header" style={{gridTemplateColumns: '1fr 1fr 1fr 1fr'}}>
                  <span>REF_ID</span>
                  <span>SOURCE</span>
                  <span>VAL</span>
                  <span>COMMISSION</span>
               </div>
               <div className="vault-table-body">
                  <div className="vault-table-row" style={{gridTemplateColumns: '1fr 1fr 1fr 1fr'}}>
                    <span className="row-name" style={{fontSize: '10px'}}>#REF-1029</span>
                    <span className="row-retailer-text">COMM. FACTORY</span>
                    <span className="row-current-price">$299.00</span>
                    <span className="row-status live">$35.88</span>
                  </div>
               </div>
             </div>
          </div>
        );

      case 'marketing':
        return (
          <div className="settings-grid animate-fade-in">
            <div className="settings-card highlight">
              <div className="settings-card-header">
                <h3>ANNOUNCEMENT_TICKER</h3>
              </div>
              <div className="settings-card-body">
                <div className="input-group-tech">
                  <input value={tickerText} onChange={(e) => setTickerText(e.target.value)} />
                </div>
                <button className="vault-purchase-btn" style={{marginTop: '20px', padding: '12px', fontSize: '1.2rem'}}>UPDATE_LIVE_FEED</button>
              </div>
            </div>
          </div>
        );

      default: return null;
    }
  };

  return (
    <div className="command-page-master technical-theme">
      <div className="command-sidebar">
        <div className="command-user-profile">
          <div className="hex-avatar" style={{borderColor: '#ff4444'}}>
            <div className="hex-inner" style={{color: '#ff4444'}}>AD</div>
            <div className="hex-ring" style={{borderColor: '#ff4444'}}></div>
          </div>
          <h3 className="user-title">ADMIN_SYSTEM</h3>
          <div className="access-tag" style={{color: '#ff4444'}}>ROOT_LEVEL_PERMISSIONS</div>
        </div>
        
        <nav className="command-nav">
          <button className={selectedTab === 'stats' ? 'active' : ''} onClick={() => setSelectedTab('stats')}>
            <span className="btn-icon"><FontAwesomeIcon icon={faChartBar} /></span>
            <span className="btn-text">OVERVIEW</span>
          </button>
          <button className={selectedTab === 'users' ? 'active' : ''} onClick={() => setSelectedTab('users')}>
            <span className="btn-icon"><FontAwesomeIcon icon={faUsr} /></span>
            <span className="btn-text">REGISTRY</span>
          </button>
          <button className={selectedTab === 'orders' ? 'active' : ''} onClick={() => setSelectedTab('orders')}>
            <span className="btn-icon"><FontAwesomeIcon icon={faCart} /></span>
            <span className="btn-text">COMMISSIONS</span>
          </button>
          <button className={selectedTab === 'marketing' ? 'active' : ''} onClick={() => setSelectedTab('marketing')}>
            <span className="btn-icon"><FontAwesomeIcon icon={faHorn} /></span>
            <span className="btn-text">MARKETING</span>
          </button>
          <div className="sidebar-footer">
            <button className="logout-btn-technical" onClick={handleLogoutClick}>
              <span className="btn-icon"><FaSignOutAlt /></span>
              <span className="btn-text">DISCONNECT</span>
            </button>
          </div>
        </nav>
      </div>
      
      <div className="command-viewport">
        <div className="viewport-overlay-grid"></div>
        <header className="viewport-header">
          <div className="header-meta">
            <span className="meta-bit" style={{color: '#ff4444'}}>LEVEL: ROOT</span>
            <span className="meta-bit">STATUS: AUTHENTICATED</span>
          </div>
          <h1 className="header-title">{selectedTab.toUpperCase()}</h1>
        </header>
        <div className="viewport-content">{renderContent()}</div>
      </div>
    </div>
  );
}

export default AdminCustomerDashboard;
